<div style="padding-bottom: 20px" class="m-content p-3">
    <div class="row">
        <div class="col-xl-2 col-lg-2">
            <!-- SKRIJ/POKAŽI FILTRE GUMB -->
            <!-- tole sem zamenjal ker se je koledar porl - ne vem zakaj -->
            <div class="mf-calendar-tool-bar">
                <ng-scrollbar sensorDebounce="1" visibility="'hover'" appearance="'compact'">
                    <button
                        (click)="isCollapsed = !isCollapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#filters"
                        class="btn btn-block btn-outline-primary m--hidden-desktop mt-3 mb-3"
                    >
                        <i class="la la-filter"></i>
                        {{ isCollapsed ? 'Pokaži filtre' : 'Skrij filtre' }}
                    </button>
                    <div id="filters" class="mf-filters-column collapse">
                        <!-- FILTRI ZA PRIKAZ RAZPOLOŽLJIVOSTI,PRAZNIKOV ITD. -->
                        <main-cal-view-filters
                            (onSearch)="filterEvents($event)"
                            (onCustomerSelected)="onCustomerSelected($event)"
                        ></main-cal-view-filters>
                        <!-- PODIZVAJALCI -->
                        <main-cal-subc [allSubcontractors]="allSubcontractors" (popUpOpened)="popupStatus($event)"></main-cal-subc>
                        <!-- PROSTORI -->
                        <main-cal-assets *ngIf="allAssets" [setAssets]="allAssets"></main-cal-assets>
                    </div>
                </ng-scrollbar>
            </div>
        </div>
        <!-- KOLEDAR -->
        <div *ngIf="!selectedFilterCustomer" class="d-md-none mobile_warning mx-auto my-1 p-3">
            Za izbiro prostega termina pridržite prst na koledarju.
        </div>
        <div class="col-xl-10 col-lg-10 pl-2">
            <main-cal-customer-search
                *ngIf="selectedFilterCustomer"
                [setCustomer]="selectedFilterCustomer"
                (onClose)="selectedFilterCustomer = undefined"
            ></main-cal-customer-search>
            <div *ngIf="!selectedFilterCustomer" class="m-portlet mb-0 h-100">
                <div class="m-portlet__body h-100">
                    <ng-container *ngIf="isSettingsLoaded">
                        <full-calendar #calendar [options]="calendarSettings" class="mf-fc-custom h-100"></full-calendar>
                    </ng-container>
                </div>
            </div>
        </div>
        <!-- OPOZORILA KO NIMAŠ IZBRANIH PODIZVAJALCEV ALI KO KOLEDAR NIMA EVENTOV PRI IZBRANI RAZPOLOŽLJIVOST-->
        <div *ngIf="rendered && settings.subconstractors.length === 0 && !popupOpened" style="z-index: 9999" class="calendar-warning">
            <div style="display: flex" class="swal2-icon swal2-warning swal2-animate-warning-icon">
                <div class="swal2-icon-content">!</div>
            </div>
            <span class="calendar-warning-title">Nimate izbranih podizvajalcev</span>
            <br />
        </div>
        <div
            *ngIf="
                rendered && (settings.filter.showOnlyAvailable || settings.filter.selectedAssets.length === 0) && allEventsCount == 0 && !popupOpened
            "
            class="calendar-warning"
        >
            <div style="display: flex" class="swal2-icon swal2-warning swal2-animate-warning-icon">
                <div class="swal2-icon-content">!</div>
            </div>
            <span class="calendar-warning-title">Za prikaz terminov spremeni filtre</span>
            <br />
            <span class="calendar-warning-text">(Prikaz, Podizvajalci, Prostori)</span>
        </div>
    </div>
</div>
<div [globalPositionConfig]="['centerH', 'top100px']" [overlayId]="10" appOverlayContent>
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text font-weight-bold">Pomoč pri uporabi eAmbulante</h3>
            </div>
        </div>
    </div>
    <div class="m-portlet__body">
        <div style="background-color: white; font-size: 1.2rem" class="px-3">
            <ul class="pl-1">
                <li>
                    <div class="m-2">Za rezervacijo termina je potrebno klikniti na meni termini in potem klikniti na prazno polje v koledarju.</div>
                </li>
                <li>
                    <div class="m-2">
                        Odprlo se vam bo okno za dodajanje nove rezervacije, kjer vnesete stranko, podizvajalca, storitev in prostor.
                    </div>
                </li>
                <li>
                    <div class="m-2">
                        Če stranka še ni bila vnesena, jo dodate s klikom na ikono z osebo (dodajanje nove stranke) v zgornjem desnem kotu okna za
                        dodajanje nove rezervacije.
                    </div>
                </li>
                <li>
                    <div class="m-2">
                        Na koncu je potrebno ustvarjeno rezervacijo še shraniti . Ustvarjena rezervacija se pokaže na koledarju terminov. Več o
                        oznakah terminov v
                        <a target="_blank" href="https://onboarding.medifit.si/clanek/oznake-terminov-in-obravnav/" class="m-link">članku</a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>
